import React, { useRef, useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import MethodDelivery from './MethodDelivery'
import MethodPickup from './MethodPickup'
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";


const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
}));


const useStyles = makeStyles((theme) => ({
    appBarSpacer: theme.mixins.toolbar,
    appBar: {
        position: 'fixed',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    appBarBottom: {
        top: 'auto',
        bottom: 0,
        padding: 10,
        background: 'white',
        boxShadow: 'none',
        [theme.breakpoints.up('sm')]: {
        },
    },
    grow: {
        flexGrow: 1,
    },
    leftLabel: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    },
    rightLabel: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



function DeliveryPickAndPayment(props) {
    const classes = useStyles();
    const [selectedInvoiceDate, setSelectedInvoiceDate] = React.useState(new Date());
    const [scheduleDeliveryDate, setScheduleDeliveryDate] = React.useState(new Date());
    const [servingMethod,setServingMethod]  = useState('delivery');
    const [isInvoiceCalendarOpen, setIsInvoiceCalendarOpen] = useState(false);
    const [isDeliverySchedCalendarOpen, setIsDeliverySchedCalendarOpen] = useState(false);

    const invoiceDateHandleDateChange = (date) => {
        setSelectedInvoiceDate(date);

    };
    const scheduleDeliveryDateHandleDateChange = (date) => {
        setScheduleDeliveryDate(date);

    };


    return (
        <div>
            <Dialog fullScreen open={props.openDeliveryPickupAndPaymentDialog} onClose={() => { props.setOpenDeliveryPickupAndPaymentDialog(false) }} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={() => { props.setOpenDeliveryPickupAndPaymentDialog(false) }}
                            aria-label="close"
                            size="large">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                            Delivery/Pick-up and Payment
                    </Typography>
                    </Toolbar>
                </AppBar>
                <div className={classes.appBarSpacer}></div>

                
                <div style={{ padding: '.5rem' }}>
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={materialTheme}>
                        <FormControl component="fieldset">
                            <RadioGroup 
                            row 
                            aria-label="position" 
                            name="delivery_method"
                            value={servingMethod}
                            onChange={(event)=>{setServingMethod(event.target.value)}}
                            >
                                <FormControlLabel value="delivery" control={<Radio color="primary" />} label="Delivery" />
                                <FormControlLabel value="pickup" control={<Radio color="primary" />} label="Pickup" />
                            </RadioGroup>
                        </FormControl>
                        </ThemeProvider>
                </StyledEngineProvider>
                    {
                        servingMethod == 'delivery' ? <MethodDelivery closeAllDialogs= {props.closeAllDialogs} sellerCompanyId={props.sellerCompanyId} /> : <MethodPickup closeAllDialogs={props.closeAllDialogs}/>
                    }
                </div>
               
            </Dialog>


        </div>
    );
}

export default DeliveryPickAndPayment